import { startTransition } from 'react';

import { getENV } from '@libs/common-next';

import css from './tabs.module.scss';

interface Props {
    value: string;
    onChange(value: string): void;
}
export function Tabs({ value, onChange }: Props) {
    const tabs = ['Feature flags', 'Cache Key', getENV('NEXT_PUBLIC_SITE_PREVIEW') && 'Site Preview'].filter(Boolean);

    return (
        <nav className={css.tabs}>
            {tabs.map(tab => (
                <label key={tab} className={css.tab}>
                    <span>{tab}</span>
                    <input
                        type="radio"
                        name="tabs"
                        checked={value === tab}
                        onChange={() => startTransition(() => onChange(tab))}
                    />
                </label>
            ))}
        </nav>
    );
}
